/**
 * Runtime configuration. In a container deployment the entrypoint (docker/entrypoint.sh)
 * generates a /config.js file that sets window.__CLOCKOO_CONFIG__ before the React bundle
 * loads. In local dev, Vite's import.meta.env is used as a fallback.
 */
export interface RuntimeConfig {
  readonly apiUrl: string;
  readonly hankoApiUrl: string;
  readonly websiteUrl: string;
}

declare global {
  interface Window {
    __CLOCKOO_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const injected = typeof window !== 'undefined' ? (window.__CLOCKOO_CONFIG__ ?? {}) : {};

export const runtimeConfig: RuntimeConfig = {
  apiUrl: injected.apiUrl ?? import.meta.env.VITE_API_URL ?? '',
  hankoApiUrl: injected.hankoApiUrl ?? import.meta.env.VITE_HANKO_API_URL ?? '',
  websiteUrl: injected.websiteUrl ?? import.meta.env.VITE_WEBSITE_URL ?? 'https://clockoo.io',
};

// Frontend version baked in at build time via VITE_APP_VERSION (set in the Dockerfile from
// the CI VERSION build-arg). Local dev falls back to "dev" so a future version badge still renders.
export const frontendVersion: string = import.meta.env.VITE_APP_VERSION ?? 'dev';
